import * as React from 'react'
export const In = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#181A93" d="M17.3 0h478.4v342H17.3z" />
    <path fill="#FFA44A" d="M0 0h513v114H0z" />
    <path fill="#1A9F0B" d="M0 228h513v114H0z" />
    <path fill="#FFF" d="M0 114h513v114H0z" />
    <circle cx={256.5} cy={171} r={34.2} fill="#FFF" />
    <path
      fill="#181A93"
      d="M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6m0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2"
    />
    <circle cx={256.5} cy={171} r={22.8} fill="#181A93" />
  </svg>
)
